import React from 'react';

import { createComponent, Layout, Header, Label, enums, PropTypes } from 'console-kit';
import authStatics from '../../../common/static';
import AuthImageLogo from '../../../components/AuthImageLogo';

const NewSessisonPanel = createComponent({
  displayName: 'NewSessisonPanel',
  propTypes:   {
    referrerLink: PropTypes.string,
  },
  defaultProps: {
    referrerLink: undefined,
  },
  render(props) {
    return (
      <div className={authStatics.SCREEN_CLASSES_WIDE}>
        <Layout isFluidHeight>
          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.CENTER}>
              <AuthImageLogo />
            </Layout.Column>
          </Layout.Row>

          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.LEFT}>
              <Header
                text="Session expired"
                isDividing={false}
                font={{
                  emphasis: enums.font.emphasis.NORMAL,
                }}
                size={enums.sizes.X6}
              />
            </Layout.Column>
          </Layout.Row>

          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.LEFT}>
              <Label
                text="When your session expires, the platform logs you out for security reasons."
                hasPadding={false}
                display={enums.display.PLAIN}
                size={enums.sizes.X4}
                isFluid
              />
            </Layout.Column>
          </Layout.Row>

          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.LEFT}>
              <Label
                text="If you saved a form just before arriving on this page, your changes will not have been saved. When you return to your previous page, please reapply your changes and save again."
                hasPadding={false}
                display={enums.display.PLAIN}
                size={enums.sizes.X4}
                isFluid
              />
            </Layout.Column>
          </Layout.Row>

          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.LEFT}>
              <Label
                text={
                  <span>
                    Click <a href={props.referrerLink}>here</a> to go back to your previous page.
                  </span>
                }
                hasPadding={false}
                display={enums.display.PLAIN}
                size={enums.sizes.X4}
                isFluid
              />
            </Layout.Column>
          </Layout.Row>
        </Layout>
      </div>
    );
  },
});

export default NewSessisonPanel;
